<template>
  <div class="h-100">
    <h1>Entomology Dashboard</h1>
    <b-container fluid class="px-0">
      <b-form-row>
        <b-col class="py-1">
          <CompoundEnrollment />
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col md="4" lg="4" class="py-1">
          <b-button variant="danger" @click="commit_light_trap_schedule">Commit Light Trap Schedule</b-button>
        </b-col>
        <b-col md="4" lg="4" class="py-1">
          
        </b-col>
        <b-col md="4" lg="4" class="py-1">
          
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col md="4" lg="4" class="py-1">
          <CoreLightTrapSchedule />
        </b-col>
        <b-col md="4" lg="4" class="py-1">
          <BufferLightTrapSchedule />
        </b-col>
        <b-col md="4" lg="4" class="py-1">
          <HLCEnrollment />
        </b-col>
      </b-form-row>
    </b-container>
  </div>
</template>

<script>
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import CoreLightTrapSchedule from "@/components/metrics/CoreLightTrapSchedule.vue";
import BufferLightTrapSchedule from "@/components/metrics/BufferLightTrapSchedule.vue";
import HLCEnrollment from "@/components/metrics/HLCEnrollment.vue";
// import Followup from "@/components/metrics/Followup.vue";
// import SampleTable from "@/components/metrics/SampleTable.vue";
// import SampleBar from "@/components/metrics/SampleBar.vue";
// import SampleHorizontalBar from "@/components/metrics/SampleHorizontalBar.vue";
// import SingleNumberA from "@/components/metrics/SingleNumberA.vue";
// import SingleNumberB from "@/components/metrics/SingleNumberB.vue";
// import ReferredSubjects from "@/components/metrics/ReferredSubjects.vue";

// import MissedVisit from "@/components/metrics/MissedVisit.vue";

import CompoundEnrollment from "@/components/metrics/CompoundEnrollment.vue";
// import EnrollmentSuccess from "@/components/metrics/EnrollmentSuccess.vue";

// import Map from "@/components/map/Map.vue";

import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import * as moment from 'moment';

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    CoreLightTrapSchedule,
    BufferLightTrapSchedule,
    HLCEnrollment,
    // Followup,
    // SampleTable,
    // SampleBar,
    // SampleHorizontalBar,
    // SingleNumberA,
    // SingleNumberB,
    // ReferredSubjects,
    // Map,
    // MissedVisit,
    CompoundEnrollment,
    // EnrollmentSuccess
  },
  methods: {
    commit_light_trap_schedule: function(){
      let next_month_name = moment().add(1, "month").startOf("month").format('MMMM').toUpperCase();
      if(!confirm("This will commit all light trap schedules for "+next_month_name+" up to CommCare tonight at 12:00 AM EAT.  Are you sure you want to continue?")){
        return
      }

      const fd = new FormData();
      fd.append('type', 'all');
      HTTP.post('/kenya/lighttraps/commit_next_month', fd).then(() => {
            alert("The light trap compounds for "+next_month_name+" will be pushed up at 12:00 AM EAT!");
      }).catch(error => {
        HandleErrors.HandleErrors(error);
      });
    },
  },
  data() {
    return {
      title: "AEGIS Data Portal Dashboard",
      compoundFollowup: {
        chartdata: {
          datasets: [
            {
              data: [13, 2],
              backgroundColor: ["green", "red"]
            }
          ],
          labels: ["Completed", "Missed"]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          circumference: Math.PI,
          rotation: -Math.PI,
          legend: {
            position: "bottom"
          },
          title: {
            display: true,
            text: "Compound Followup Visits"
          },
          animation: {
            animateScale: true,
            animateRotate: true
          }
        }
      },
      clinicVisits: {
        chartdata: {
          labels: [],
          datasets: [
            {
              label: "Completed",
              backgroundColor: "red",
              stack: "Stack 0",
              data: [5]
            },
            {
              label: "Missed",
              backgroundColor: "blue",
              stack: "Stack 0",
              data: [10]
            },
            {
              label: "Late",
              backgroundColor: "green",
              stack: "Stack 0",
              data: [7]
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "bottom"
          },
          title: {
            display: true,
            text: "Clinic Visits"
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false
                }
              }
            ],
            yAxes: [
              {
                barThickness: 70,
                gridLines: {
                  display: false
                }
              }
            ]
          }
        }
      }
    };
  }
};
</script>

<style></style>
